/**
 * Normalizes typing for controlled decimal amount fields (avoids a stuck leading "0").
 * Allows "", strips junk, one decimal point, and normalizes the whole part with parseInt
 * so values like "088" become "88" while keeping decimals such as "0.50".
 */
export function normalizeDecimalTyping(raw) {
  if (raw === "") return "";
  const cleaned = raw.replace(/[^\d.]/g, "");
  const dot = cleaned.indexOf(".");
  if (dot === -1) {
    if (cleaned === "") return "";
    const n = parseInt(cleaned, 10);
    return Number.isNaN(n) ? "" : String(n);
  }
  const intRaw = cleaned.slice(0, dot);
  const decPart = cleaned.slice(dot + 1).replace(/\./g, "");
  let intDisplay;
  if (intRaw === "") intDisplay = "0";
  else {
    const n = parseInt(intRaw, 10);
    intDisplay = Number.isNaN(n) ? "0" : String(n);
  }
  if (decPart.length) return `${intDisplay}.${decPart}`;
  if (cleaned.endsWith(".")) return `${intDisplay}.`;
  return intDisplay;
}
